import { put, call, select } from 'redux-saga/effects';
import * as routes from 'app/routes';
import { authenticateUser } from 'auth/sagas';
import { createRenewal } from 'billing/purchases/sagas';
import { createRenewal as createRenewalAction } from 'billing/purchases/actions';
import { getRenewalPurchase, getUser } from 'reducers';

export function* renewNavigate() {
  yield call(authenticateUser);
  // TODO: confirm renewal is necessary
  const user = yield select(getUser);
  yield call(createRenewal, createRenewalAction(user.id));
  const purchase = yield select(getRenewalPurchase);
  yield put(routes.unpaidPurchase(purchase.id));
}
